<!-- Bloc de gauche -->
<ng-container *ngIf="bloc === 'gauche'">
    <div>
        <div class="grid justify-items-center">
            <div class="font-medium mb-5 text-center text-secondary">
                <div translate>lingueopro.dashboard.upcoming_sessions.Passage du LILATE</div>
            </div>

            <div *ngIf="isPendingAssessment" translate>
                lilate-exam.session-content.isPendingAssessment
            </div>

            <div class="font-extrabold text-2xl">{{ lilate.start | amLocale: 'fr' | amDateFormat:'dddd DD MMMM' }}</div>
            <div class="font-extrabold text-2xl"
                [translateParams]="{start: lilate.start | amLocale: getCurrentLanguage() | amDateFormat:'HH:mm', end: lilate.end | amLocale: getCurrentLanguage() | amDateFormat:'HH:mm'}"
                translate>lingueopro.plan-formation.conclusion.date-slot-time
            </div>
            <div>
                <span [innerHTML]="countdownStatus | translate"></span>
                &nbsp;
                <span *ngIf="!isPendingAssessment">{{countdown}} :</span>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!isPendingAssessment">
        <button [disabled]="!providerRequirements" (click)="openTeamsLink()"
            [ngClass]="{'bg-gray-300': !providerRequirements, 'text-green-100': providerRequirements, 'bg-green-500': providerRequirements}"
            class="w-full  mt-10 lg:mt-auto" mat-flat-button>
            <span translate>lilate-exam.session-content.join
            </span>
        </button>
        <div class="booked-guidance" *ngIf="lilate.status === 'identity_issue'" translate>
            lilate-exam.session-content.identity_issue
        </div>
    </ng-container>

    <div class="grid justify-items-start mt-5">
        <button [disabled]="isCancellationLocked()" (click)="changeDateLilate(lilate)"
            [ngClass]="{'bg-gray-300': isCancellationLocked(), 'text-green-100': !isCancellationLocked(), 'bg-green-500': !isCancellationLocked()}"
            class="w-full  mt-10 lg:mt-auto" mat-flat-button>
            <span translate>lilate-exam.session-content.change-date</span>
        </button>
    </div>
</ng-container>

<!-- bloc de droite -->
<ng-container *ngIf="bloc === 'droite'">
    <!-- LILATE EN COURS -->
    <div class="mt-2 leading-relaxed text-secondary">
        <div *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && !isPendingAssessment">
            <div translate class="mt-10 text-xl" *ngIf="!providerRequirements">
                lilate-exam.session-content.booked-guidance
            </div>
        </div>
    </div>

    <div class="flex items-center mt-10">
        <div class="font-medium text-secondary" translate>lilate.prep.testHeading</div>
        <div class="flex-auto ml-2 border-b-2"></div>
    </div>
    <!-- Features -->
    <div class="grid grid-cols-1 gap-y-4 mt-6">
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:arrow-circle-right'"></mat-icon>
            <div class="ml-2" translate>lilate.prep.idRequirement</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:arrow-circle-right'"></mat-icon>
            <div class="ml-2 underline cursor-pointer" (click)="openSetupMedia()" translate>lilate.prep.checkMedia</div>
        </div>
    </div>
    
</ng-container>